import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(data);
        navigate("/calculator", { replace: true, state: { user: data } });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div
      data-testid="auth-callback-loading"
      className="min-h-screen flex items-center justify-center bg-brand-bone"
    >
      <div className="text-center">
        <div className="w-10 h-10 mx-auto rounded-full border-2 border-brand-forest border-t-transparent animate-spin" />
        <p className="mt-4 text-sm text-brand-muted">Signing you in…</p>
      </div>
    </div>
  );
}
